import WagsLogo from "@/assets/icons/wags-logo.svg";

export function PhotoLoadingIndicator() {
    return (
        <span aria-hidden="true" className="block h-6 w-16">
            <WagsLogo className="size-full text-doberman-black/10 motion-safe:animate-pulse" />
        </span>
    );
}
